import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { cookieUtils } from '../utils/cookies';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute component that checks for valid access token
 * Only renders children if access token is available
 * Redirects to login if no token is found
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  
  // Check if access token exists
  const accessToken = cookieUtils.getAccessToken();
  
  // If no token, redirect to login
  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Render children if token exists
  // Token validity will be checked by API calls and handled by the HTTP interceptor
  return <>{children}</>;
};

export default ProtectedRoute;

